module.exports = __webpack_public_path__ + "img/icon-ActForex.d236b6ef.png";